/* eslint-disable import/no-anonymous-default-export */
const Close = ()=>(
    <svg width="22" height="22" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.41699 6.91699L15.5837 16.0837" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.41699 16.0837L15.5837 6.91699" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export default {Close}